import { Component, EventEmitter, Input, Output, ViewChild, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { NgbDropdown, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Actions, ofType } from '@ngrx/effects';
import { take } from 'rxjs/operators';
import { Subscription, BehaviorSubject } from 'rxjs';
import { ExportConfiguration, ExportOption } from '../../models/export.model';

@Component({
  selector: 'app-export',
  templateUrl: './export.component.html',
  styleUrls: ['./export.component.scss']
})
export class ExportComponent implements OnInit {
  @ViewChild('myDropdown') myDropdown: NgbDropdown;
  @Input() public exportConfig: ExportConfiguration;
  @Output() public submitClickEvent = new EventEmitter<ExportOption>();

  public selectedOption: ExportOption;

  public loading$ = new BehaviorSubject(null);
  private readonly subscription: Subscription = new Subscription();

  form = new FormGroup({});

  constructor(private modalService: NgbModal, private actions$: Actions) { }

  ngOnInit() {
    this.selectedExport(this.exportConfig.exportOptions[0]);
  }

  selectedExport(selected: ExportOption) {
    // Remove previous form controls
    if (selected !== this.selectedOption && this.selectedOption !== undefined) {
      for (const fieldName of this.selectedOption.fields) {
        this.form.removeControl(fieldName);
      }
    }
    this.selectedOption = selected;
    for (const fieldName of selected.fields) {
      this.form.addControl(fieldName, new FormControl(true));
    }
  }

  onSubmit() {
    this.subscription.add(
      this.actions$.pipe(
        ofType(this.selectedOption.actionSuccessClass, this.selectedOption.actionFailureClass),
        take(1)
      ).subscribe(() => {
        this.loading$.next(false);
      })
    );
    this.loading$.next(true);
    this.submitClickEvent.next(this.selectedOption);
  }

  closeModal() {
    this.modalService.dismissAll();
  }
}
